module.exports = __webpack_public_path__ + "static/media/findprovider-yellow.e27c67c7.svg";